import Vue from "vue";
import Router from "vue-router";

import Home from "@/pages/Home";
import Video from "@/pages/Video";
import Activity from "@/pages/activity/Activity";
import ActivityMatch from "@/pages/activity/Match";
import ActivityLunch from "@/pages/activity/ActivityLunch";
import NewActivityLunch from "@/pages/activity/newActivityLunch";
import addmatch from "@/pages/activity/addmatch.vue";
import activityWrap from "@/pages/activity/activityWrap";
import ActivityDetail from "@/pages/activity/match/Detail";
import ActivityAllWorks from "@/pages/activity/match/AllWorks";
import ActivityParticipant from "@/pages/activity/match/Participants";
import picture from "@/pages/activity/match/Picture";
import ActivityMyCreation from "@/pages/activity/match/MyCreation";
import ActivityWinningCreation from "@/pages/activity/match/WinningWorks";
import ActivityAbout from "@/pages/activity/match/About";
import ActivityMatchSignUp from "@/pages/activity/SignUp";
import Download from "@/pages/Download";
import identification from "@/pages/identification";
// import peopleCenter from "@/pages/peopleCenter";
import PeopleCenter from "@/pages/v2/peopleCenter/PeopleCenter";
import PeopleCenterHome from "@/pages/v2/peopleCenter/step/Home";
import PeopleCenterVideo from "@/pages/v2/peopleCenter/step/Video";
import peopleCenterCollect from "@/pages/v2/peopleCenter/step/collect";
import PeopleCenterArticle from "@/pages/v2/peopleCenter/step/Article";
import PeopleCenterLive from "@/pages/v2/peopleCenter/PeopleCenterLive"
import PeopleCenterLike from "@/pages/v2/peopleCenter/step/Like";
import PeopleCenterIntroduce from "@/pages/v2/peopleCenter/step/Introduce";
import peopleCenterRecruit from "@/pages/v2/peopleCenter/step/recruit";
import PeopleCenterActivity from "@/pages/v2/peopleCenter/PeopleCenterActivity";



import CorporationHome from "@/pages/CorporationHome";
import manageCenter from "@/pages/my/account/manageCenter";
import cancel from "@/pages/my/account/cancel";
import ApplyIdentification from "@/pages/my/account/ApplyIdentification";
import playRecord from "@/pages/my/account/playRecord";
import manageVideo from "@/pages/my/video/manageVideo";
import videoComment from "@/pages/my/video/videoComment";
import MyCollect from "@/pages/my/account/Collect";
import MyFocus from "@/pages/my/account/Focus";
import MySpecialSubject from "@/pages/my/account/SpecialSubject";
import MyLike from "@/pages/my/account/Like";
import MyMaJiang from "@/pages/my/account/MaJiang";
import MySubscribe from "@/pages/my/account/Subscribe";
import MyActivity from "@/pages/my/activity/Activity";
import MyCompetition from "@/pages/my/activity/Competition";
import MessageCenter from "@/pages/MessageCenter";

import UpVideo from "@/pages/my/video/UpVideo";
import PerfectUserInfo from "@/pages/my/video/PerfectUserInfo";
import MatchUpVideo from "@/pages/my/video/MatchUpVideo";
import Lifegeek from "@/pages/match/lifegeekhomePz";
import LifegeekPrize from "@/pages/match/prizePz";
import rwlifegeek from "@/pages/match/rwlifegeekhomePz";

import signupZ from "@/pages/match/signupPz";
import publishPage from "@/pages/subject/publishPage";
import discussDetail from "@/pages/subject/discussDetails"


import Eventin from '@/pages/match/eventintroPz'
import Contest from '@/pages/match/Contest';
import ContestEnter from '@/pages/match/ContestEnter';
import ShortlistedEntries from "@/pages/match/shortlistedEntries";
import Works from "@/pages/match/works";
import information from "@/pages/match/information"
import ContestHome from "@/pages/match/contestHome";
import contestPage from "@/pages/match/contestPage";
import ContestAwards from "@/pages/match/contestAwards";

import MatchSupplement from '@/pages/match/MatchSupplement'
import VideoSuccess from '@/pages/my/video/VideoSuccess'

import competitionUpVideo from "@/pages/competitionUpVideo";
import Login from "@/pages/passport/Login";
import Reg from "@/pages/passport/Reg";
import SetInfo from "@/pages/passport/SetInfo";


import forgetPassword from "@/pages/passport/forgetPassword";
import resetPassword from "@/pages/passport/resetPassword";
import channel from "@/pages/explore/channel";
import ExploreVideo from "@/pages/explore/ExploreVideo";
import ExploreAuth from "@/pages/explore/ExploreAuth";
import ExploreSubject from "@/pages/explore/ExploreSubject";

import SubjectContent from '@/pages/v2/subject/SubjectContent';
import SubjectDetailHome from '@/pages/v2/subject/channel/Home';
import SubjectDetailVideo from '@/pages/v2/subject/channel/Video';
import SubjectDetailEvent from '@/pages/v2/subject/channel/Event';
import SubjectDetailActivity from '@/pages/v2/subject/channel/Activity';
import SubjectDetailMember from '@/pages/v2/subject/channel/Member';
import SubjectDetailCreator from '@/pages/v2/subject/channel/Creator';

import SubjectDetail from "@/pages/subject/SubjectDetail";
import SubjectMember from "@/pages/subject/SubjectMember";

import SubjectEdit from '@/pages/v2/subject/SubjectEdit';
import SubjectEditStep1 from "@/pages/v2/subject/step/Step1";
import SubjectEditStep2 from "@/pages/v2/subject/step/Step2";
import SubjectEditStep3 from "@/pages/v2/subject/step/Step3";
import SubjectEditStep4 from "@/pages/v2/subject/step/Step4";
import SubjectEditStep5 from "@/pages/v2/subject/step/Step5";
import SubjectEditStep6 from "@/pages/v2/subject/step/Step6";

import ArticleIndex from '@/pages/v2/article/ArticleIndex';
import ArticleEdit from '@/pages/v2/article/ArticleEdit';
import ArticlePreView from '@/pages/v2/article/ArticlePreView';
import ArticleDetail from '@/pages/v2/article/ArticleDetail';

import MyArticle from '@/pages/v2/my/account/MyArticle';
import myOrder from '@/pages/v2/my/account/myOrder';


import AcademyHome from "@/pages/academy/home";
import JobsHome from "@/pages/jobs/home";
import payMeal from "@/pages/payMeal/home";
import AcademyOfflineCourseList from "@/pages/academy/offlineCourseList";
import Live from "@/pages/newLive/list";
import LivePage from "@/pages/newLive/livePage";
import LiveDetail from "@/pages/newLive/liveDetail";
import mealSuc from "@/pages/newLive/mealSuc";
import PayDetail from "@/pages/newLive/PayDetail";
import PaySuc from "@/pages/newLive/PaySuc";

import artSchool from "@/pages/subject/artSchoolPage";

import emailink from "@/pages/passport/emailink";
import OnOffIntroduce from "@/pages/activity/onOffLineActivity/OnOffIntroduce";
import addPeople from "@/pages/activity/onOffLineActivity/addPeople";
import activityPicture from "@/pages/activity/onOffLineActivity/activityPicture";
import onOffaboutOwner from "@/pages/activity/onOffLineActivity/onOffaboutOwner";
import about from "@/pages/page/about";
// import Search from "@/pages/search/Search";
import newSearch from "@/pages/search/newSearch";
import Auth from "@/pages/passport/auth";
import NotFound from "@/pages/error/404";
import project from "@/pages/project/project";
import takeProject from "@/pages/project/takeProject";
import caseProject from "@/pages/project/caseProject";
import projectDetails from "@/pages/project/projectDetails";
import PublicAgreement from '@/pages/project/PublicAgreement';
import weChatPay from '@/pages/weChat/weChat'
import comm from "@/assets/comm.js";
import lookFolder from '@/pages/lookFolder/lookFolder';

import HotList from "@/pages/hotList/hotList"
//设计周
import Dateforum2019 from '@/pages/event/Dateforum2019';

//商务合作
import business from '@/pages/business/business';
//广告刊例
import advertisement from '@/pages/business/advertisement';
//产商服务
import service from '@/pages/business/service';
//年度盘点
import yearList2020 from '@/pages/yearList/yearList2020';
import yearList2021 from '@/pages/yearList/yearList2021';
import CQILAC2022 from '@/pages/yearList/CQILAC2022';
import CQILAC2023 from '@/pages/yearList/CQILAC2023';
import releasePosition from '@/pages/recruit/releasePosition'
import recruitDetail from '@/pages/recruit/recruitDetail'
import MyRecruit from '@/pages/my/account/MyRecruit'
import Resume from '@/pages/my/account/Resume'
import jobWanted from '@/pages/my/account/jobWanted'
import MyResume from '@/pages/my/account/MyResume'
import previewResume from '@/pages/my/account/previewResume'

//国美毕展
const guomei = () => import ('@/pages/guomei/guomei');
const guomeiList = () => import ('@/pages/guomei/guomeiList');

const VideoIframe = () => import("@/pages/share/VideoIframe");

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "MANA - 全球新媒体艺术平台 - 艺术/设计/科技/跨界创新"
      }
    },
    {
      path: "/subjectDetail/:id",
      name: "subjectContent",
      component: SubjectContent,
      redirect: { name: "subjectDetailHome" },
      children: [
        {
          path: "home",
          name: "subjectDetailHome",
          component: SubjectDetailHome,
        },
        {
          path: "video",
          name: "subjectDetailVideo",
          component: SubjectDetailVideo,
        },
        {
          path: "event",
          name: "subjectDetailEvent",
          component: SubjectDetailEvent,
        },
        {
          path: "activity",
          name: "subjectDetailActivity",
          component: SubjectDetailActivity,
        },
        {
          path: "creator",
          name: "subjectDetailCreator",
          component: SubjectDetailCreator,
        },
        {
          path: "member",
          name: "subjectDetailMember",
          component: SubjectDetailMember,
        },
      ]
    },
    {
      path: "/project",
      name: "project",
      component: project,
    },
    {
      path: "/takeProject",
      name: "takeProject",
      component: takeProject,
    },
    {
      path: "/caseProject",
      name: "caseProject",
      component: caseProject,
    },
    {
      path: "/projectDetail/:id",
      name: "projectDetails",
      component: projectDetails,
    },
    {
      path: '/treaty/:id',
      component: PublicAgreement,
      meta: {
        titlt: '隐私政策 | MANA'
      }
    },
    {
      path: "/video/detail",
      name: "Video/detail",
      component: Video,
      meta: {
        title: "视频页 | MANA"
      }
    },
    {
      path: "/activity/:category?",
      name: "Activity",
      component: Activity,
      meta: {
        title: "活动页 | MANA"
      }
    },
    {
      path: "/activityMatch/:id",
      name: "match",
      redirect: { name: "matchIntroduction" },
      component: ActivityMatch,
      children: [
        {
          path: "introduction",
          name: "matchIntroduction",
          component: ActivityDetail,
          meta: {
            title: "竞赛介绍 | MANA"
          }
        },
        {
          path: "allWorks",
          name: "matchAllWorks",
          component: ActivityAllWorks,
          meta: {
            title: "全部作品 | MANA"
          }
        },
        {
          path: "participant",
          name: "matchParticipant",
          component: ActivityParticipant,
          meta: {
            title: "参赛人员 | MANA"
          }
        },
        {
          path: "myCreation",
          name: "matchMyCreation",
          component: ActivityMyCreation,
          meta: {
            title: "我的作品 | MANA"
          }
        },
        {
          path: "winningWorks",
          name: "matchWinningWorks",
          component: ActivityWinningCreation,
          meta: {
            title: "获奖作品 | MANA"
          }
        },
        {
          path: "about",
          name: "matchAbout",
          component: ActivityAbout,
          meta: {
            title: "关于主办方 | MANA"
          }
        }
      ]
    },
    {
      path: "/activity/:id",
      name: "activityWrap",
      redirect: { name: "activityIntroduction" },
      component: activityWrap,
      children: [
        {
          path: "detail",
          name: "activityIntroduction",
          component: ActivityDetail,
          meta: {
            title: "活动介绍 | MANA"
          }
        },
        {
          path: "participant",
          name: "activityParticipant",
          component: ActivityParticipant,
          meta: {
            title: "报名人员 | MANA"
          }
        },
        {
          path: "picture",
          name: "picture",
          component: picture,
          meta: {
            title: "活动照片 | MANA"
          }
        }
      ]
    },
    {
      path: "/activityDetail",
      redirect: { name: "activityDetail" },
      component: activityWrap,
      children: [
        {
          path: ":id",
          name: "activityDetail",
          component: ActivityDetail,
          meta: {
            title: "活动介绍 | MANA"
          }
        },
        {
          path: "picture/:id",
          name: "pictureId",
          component: picture,
          meta: {
            title: "活动照片 | MANA"
          }
        }
      ]
    },
    {
      path: "/OnOffIntroduce",
      name: "OnOffIntroduce",
      component: OnOffIntroduce,
      meta: {
        title: "线上线下活动详情 | MANA"
      }
    },
    {
      path: "/addPeople",
      name: "addPeople",
      component: addPeople,
      meta: {
        title: "活动报名 | MANA"
      }
    },
    {
      path: "/activityPicture",
      name: "activityPicture",
      component: activityPicture,
      meta: {
        title: "活动照片 | MANA"
      }
    },
    {
      path: "/onOffaboutOwner",
      name: "onOffaboutOwner",
      component: onOffaboutOwner,
      meta: {
        title: "关于主办方 | MANA"
      }
    },
    {
      path: "/activityMatch/:id/signUp",
      name: "competitionSignUp",
      component: ActivityMatchSignUp,
      meta: {
        title: "比赛报名 | MANA"
      }
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
      meta: {
        title: "下载页 | MANA"
      }
    },
    {
      path: "/identification",
      name: "identification",
      component: identification,
      meta: {
        title: "认证合作艺术家 | MANA"
      }
    },
    /**兼容老的消息等. */
    {
      path: "/peopleCenter",
      redirect: to => {
        return `/peopleCenter/${to.query.userId}/home`
      }
    },
    {
      path: "/peopleCenter/:userId",
      component: PeopleCenter,
      props: true,
      redirect: { name: "peopleCenterHome" },
      children: [
        {
          path: "home",
          name: "peopleCenterHome",
          component: PeopleCenterHome,
          meta: {
            title: "主页 | MANA"
          }
        },
        {
          path: "video",
          name: "peopleCenterVideo",
          component: PeopleCenterVideo,
          meta: {
            title: "作品 | MANA"
          }
        },
        {
          path: "article",
          name: "peopleCenterArticle",
          component: PeopleCenterArticle,
          meta: {
            title: "文章 | MANA"
          }
        },
        {
          path: "like",
          name: "peopleCenterLike",
          component: PeopleCenterLike,
          meta: {
            title: "喜欢 | MANA"
          }
        },
        {
          path: "collect",
          name: "peopleCenterCollect",
          component: peopleCenterCollect,
          meta: {
            title: "看单 | MANA"
          }
        },
        {
          path: "introduce",
          name: "peopleCenterIntroduce",
          component: PeopleCenterIntroduce,
          meta: {
            title: "简介 | MANA"
          }
        },
        {
          path: "recruit",
          name: "peopleCenterRecruit",
          component: peopleCenterRecruit,
          meta: {
            title: "招聘职位 | MANA"
          }
        }
      ]
    },
    {
      path: "/peopleCenter/:userId/activity",
      name: "peopleCenterActivity",
      props: true,
      component: PeopleCenterActivity,
      meta: {
        title: "发起的活动 | MANA"
      }
    },
    {
      path: "/peopleCenter/:userId/live",
      name: "PeopleCenterLive",
      component: PeopleCenterLive,
      meta: {
        title: "参与的直播 | MANA"
      }
    },
    {
      path: "/CorporationHome",
      name: "CorporationHome",
      component: CorporationHome,
      meta: {
        title: "简介 | MANA"
      }
    },
    {
      path: "/manageCenter",
      name: "manageCenter",
      component: manageCenter,
      meta: {
        title: "用户中心 | MANA"
      }
    },
    {
      path: "/cancel",
      name: "cancel",
      component: cancel,
      meta: {
        title: "注销账号 | MANA"
      }
    },
    {
      path: "/ApplyIdentification",
      name: "ApplyIdentification",
      component: ApplyIdentification,
      meta: {
        title: "申请认证 | MANA"
      }
    },
    {
      path: "/playRecord",
      name: "playRecord",
      component: playRecord,
      meta: {
        title: "播放记录 | MANA"
      }
    },
    {
      path: "/manageVideo",
      name: "manageVideo",
      component: manageVideo,
      meta: {
        title: "管理视频 | MANA"
      }
    },
    {
      path: "/videoComment",
      name: "videoComment",
      component: videoComment,
      meta: {
        title: "视频评论 | MANA"
      }
    },
    {
      path: "/MyCollect",
      name: "MyCollect",
      component: MyCollect,
      meta: {
        title: "我的收藏 | MANA"
      }
    },
    {
      path: "/MyFocus",
      name: "MyFocus",
      component: MyFocus,
      meta: {
        title: "我的关注 | MANA"
      }
    },
    {
      path: "/MySpecialSubject",
      name: "MySpecialSubject",
      component: MySpecialSubject,
      meta: {
        title: "我的频道 | MANA"
      }
    },
    {
      path: "/MyLike",
      name: "MyLike",
      component: MyLike,
      meta: {
        title: "我的点赞 | MANA"
      }
    },
    {
      path: "/MyMaJiang",
      name: "MyMaJiang",
      component: MyMaJiang,
      meta: {
        title: "我的嘛酱 | MANA"
      }
    },
    {
      path: "/MySubscribe",
      name: "MySubscribe",
      component: MySubscribe,
      meta: {
        title: "我的订阅 | MANA"
      }
    },
    {
      path: "/MyActivity",
      name: "MyActivity",
      component: MyActivity,
      meta: {
        title: "我的活动 | MANA"
      }
    },
    {
      path: "/my/article",
      name: "myArticle",
      component: MyArticle,
      meta: {
        title: "我的文章 | MANA"
      }
    },
    {
      path: "/my/order",
      name: "myOrder",
      component: myOrder,
      meta: {
        title: "我的订单 | MANA"
      }
    },
    {
      path: "/MyCompetition",
      name: "MyCompetition",
      component: MyCompetition,
      meta: {
        title: "我的比赛 | MANA"
      }
    },
    {
      path: "/MessageCenter",
      name: "MessageCenter",
      component: MessageCenter,
      meta: {
        title: "消息中心 | MANA"
      }
    },
    {
      path: "/UpVideo",
      name: "UpVideo",
      component: UpVideo,
      meta: {
        title: "上传视频| MANA"
      }
    },
    {
      path: "/UpVideo/perfectUserInfo",
      name: "perfectUserInfo",
      component: PerfectUserInfo,
      meta: {
        title: "完善资料| MANA"
      },
    },
    {
      path: "/MatchUpVideo",
      name: "MatchUpVideo",
      component: MatchUpVideo,
      meta: {
        title: "上传视频| MANA"
      }
    },
    {
      path: '/match/presentfuture',
      name: 'presentfuture',
      component: Eventin,
      meta: {
        title: '2019“现未来”科技艺术之星奖-竞赛介绍| MANA'
      }
    },
    {
      path: "/match/awards",
      name: "awards",
      component: LifegeekPrize,
      meta: {
        title: "2019“现未来”科技艺术之星奖-获奖公示| MANA"
      }
    },
    {
      path: "/match/shortlistedEntries",
      name: "entries",
      component: rwlifegeek,
      meta: {
        title: "2019“现未来”科技艺术之星奖-入围作品| MANA"
      }
    },
    {
      path: "/match/works",
      name: "works",
      component: Lifegeek,
      meta: {
        title: "2019“现未来”科技艺术之星奖-参赛作品| MANA"
      }
    },
    {
      path: "/signupZ",
      name: "signupZ",
      component: signupZ,
      meta: {
        title: "signupZ| MANA"
      }
    },
    {
      path: "/publishPage",
      name: "publishPage",
      component: publishPage,
      meta: {
        title: "publishPage| MANA"
      }
    },
    {
      path: "/discussDetail",
      name: "discussDetail",
      component: discussDetail,
      meta: {
        title: "问答详情| MANA"
      }
    },
    {
      path: '/match/:contestName',
      name: 'contest',
      redirect: '/match/:contestName/home',
      component: Contest,
      meta: {
        title: '竞赛| MANA'
      }, children: [
        {
          path: 'home',
          name: 'contestHome',
          component: ContestHome,
          meta: {
            title: '竞赛首页 | MANA'
          },
        },
        {
          path: 'page',
          name: 'contestPage',
          component: contestPage,
          meta: {
            title: '竞赛子页面 | MANA'
          },
        },
        {
          path: 'awards',
          name: 'contestAwards',
          component: ContestAwards,
          meta: {
            title: '竞赛首页 | MANA'
          },
        },
        {
          path: 'shortlistedEntries',
          name: 'shortlistedEntries',
          component: ShortlistedEntries,
          meta: {
            title: '入围作品 | MANA'
          },
        }, {
          path: 'works',
          name: 'competitionWorks',
          component: Works,
          meta: {
            title: '参赛作品 | MANA'
          }
        }, {
          path: 'information',
          name: 'information',
          component: information,
          meta: {
            title: '赛事资讯 | MANA'
          }
        }
      ]
    },
    {
      path: '/match/:contestName/enter',
      name: 'contestEnter',
      component: ContestEnter,
      meta: {
        title: '提交作品 | MANA'
      },
    },
    {
      path: '/matchSupplement/:matchId/:videoId',
      name: 'matchSupplement',
      component: MatchSupplement,
      meta: {
        title: '填写竞赛投稿信息| MANA'
      }
    },
    {
      path: '/videoSuccess/:videoId',
      name: 'videoSuccess',
      component: VideoSuccess,
      meta: {
        title: '视频 | MANA'
      }
    },
    //视频分享页面
    {
      path: "/video/:videoId",
      name: "videoIframe",
      component: VideoIframe,
      meta: {
        title: "视频嵌入页 | MANA"
      }
    },
    //设计周
    {
      path: "/event/dateforum2019",
      component: Dateforum2019,
      meta: {
        title: "date 上海设计周先锋论坛 | MANA"
      }
    },
    {
      path: "/competitionUpVideo",
      name: "competitionUpVideo",
      component: competitionUpVideo,
      meta: {
        title: "上传比赛视频| MANA"
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "登录 | MANA"
      }
    },
    {
      path: "/reg",
      name: "Reg",
      component: Reg,
      meta: {
        title: "注册 | MANA"
      }
    },
    {
      path: "/setInfo/:step",
      name: "setInfo",
      component: SetInfo,
      meta: {
        title: "设置资料 | MANA"
      }
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      component: forgetPassword,
      meta: {
        title: "忘记密码 | MANA"
      }
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      component: resetPassword,
      meta: {
        title: "重置密码 | MANA"
      }
    },
    {
      path: "/channel/:type",
      name: "channel",
      component: channel,
      meta: {
        title: "频道 | MANA"
      }
    },
    {
      path: "/academy/home",
      name: "AcademyHome",
      component: AcademyHome,
      meta: {
        title: "MANA学院"
      }
    },
    {
      path: "/jobs/home",
      name: "JobsHome",
      component: JobsHome,
      meta: {
        title: "MANA招聘"
      }
    },
    {
      path: "/payMeal/home",
      name: "payMeal",
      component: payMeal,
      meta: {
        title: "购买套餐"
      }
    },
    {
      path: "/live/list",
      name: "Live",
      component: Live,
      meta: {
        title: "MANA直播"
      }
    },
    {
      path: "/live/livePage",
      name: "LivePage",
      component: LivePage,
      meta: {
        title: "MANA直播"
      }
    },
    {
      path: "/live/liveDetail",
      name: "LiveDetail",
      component: LiveDetail,
      meta: {
        title: "MANA直播"
      }
    },
    {
      path: "/meal/mealSuc",
      name: "mealSuc",
      component: mealSuc,
      meta: {
        title: "MANA招聘"
      }
    },
    {
      path: "/live/payDetail",
      name: "payDetail",
      component: PayDetail,
      meta: {
        title: "MANA直播"
      }
    },
    {
      path: "/live/paySuc",
      name: "paySuc",
      component: PaySuc,
      meta: {
        title: "MANA直播"
      }
    },
    {
      path: "/weChat/weChatPay",
      name: "weChat",
      component: weChatPay,
      meta: {
        title: "微信支付"
      }
    },
    {
      path: "/academy/offlineCourse",
      name: "AcademyOfflineCourseList",
      component: AcademyOfflineCourseList,
      meta: {
        title: "MANA学院-付费课程"
      }
    },
    {
      path: "/explorevideo",
      name: "ExploreVideo",
      component: ExploreVideo,
      meta: {
        title: "发现视频 | MANA"
      }
    },
    {
      path: "/exploreauth",
      name: "ExploreAuth",
      component: ExploreAuth,
      meta: {
        title: "发现创作者 | MANA"
      }
    },
    {
      path: "/exploresubject",
      name: "ExploreSubject",
      component: ExploreSubject,
      meta: {
        title: "发现频道 | MANA"
      }
    },
    {
      path: "/subjectdetail",
      name: "SubjectDetail",
      redirect: to => {
        return `/subjectdetail/${to.query.id}/home`
      }
    },
    {
      path: "/artSchool",
      name: "artSchool",
      component: artSchool
    },
    {
      path: "/subjectmember",
      name: "SubjectMember",
      component: SubjectMember
    },
    {
      path: "/subject/edit/:id",
      name: "subjectEdit",
      component: SubjectEdit,
      meta: {
        title: "频道修改 | MANA"
      },
      children: [
        {
          path: "step1",
          name: "subjectEditStep1",
          component: SubjectEditStep1
        },
        {
          path: "step2",
          name: "subjectEditStep2",
          component: SubjectEditStep2
        },
        {
          path: "step3",
          name: "subjectEditStep3",
          component: SubjectEditStep3
        },
        {
          path: "step4",
          name: "subjectEditStep4",
          component: SubjectEditStep4
        },
        {
          path: "step5",
          name: "subjectEditStep5",
          component: SubjectEditStep5
        },
        {
          path: "step6",
          name: "subjectEditStep6",
          component: SubjectEditStep6
        }
      ]
    },
    {
      path: '/subject/create',
      name: "subjectCreate",
      redirect: { name: "subjectCreateStep1" },
      component: SubjectEdit,
      meta: {
        title: "频道设置 | MANA"
      },
      children: [
        {
          path: "step1",
          name: "subjectCreateStep1",
          component: SubjectEditStep1
        }
      ]
    },
    {
      path: '/article',
      name: 'articleIndex',
      component: ArticleIndex,
      meta: {
        title: "文章列表 | MANA"
      }
    },
    {
      path: '/article/edit',
      name: 'articleEdit',
      component: ArticleEdit,
      meta: {
        title: "写文章 | MANA"
      }
    },
    {
      path: '/article/preview/:id',
      name: 'articlePreView',
      component: ArticlePreView,
      meta: {
        title: "预览 | MANA"
      }
    },
    {
      path: '/article/detail/:id',
      name: 'articleDetail',
      component: ArticleDetail,
      meta: {
        title: "文章详情 | MANA"
      }
    },
    {
      path: "/emailink",
      name: "emailink",
      component: emailink,
      meta: {
        title: "邮箱认证 | MANA"
      }
    },

    {
      path: "/about/:title",
      name: "about",
      component: about,
      meta: {
        title: "关于我们 | MANA"
      }
    },
    // {
    //   path: "/Search/:content/:type/:videotype",
    //   name: "Search",
    //   component: Search,
    //   meta: {
    //     title: "搜索页 | MANA"
    //   }
    // },
    {
      path: "/Search",
      name: "newSearch",
      component: newSearch,
      meta: {
        title: "搜索页 | MANA"
      }
    },
    {
      path: "/ActivityLunch",
      name: "ActivityLunch",
      component: ActivityLunch,
      meta: {
        title: "发起活动-竞赛 | MANA"
      }
    },
    {
      path: "/newActivityLunch",
      name: "newActivityLunch",
      component: NewActivityLunch,
      meta: {
        title: "线下活动 | MANA"
      }
    },
    {
      path: "/addmatch",
      name: "addmatch",
      component: addmatch,
      meta: {
        title: "创建比赛 | MANA"
      }
    },
    {
      path: "/business",
      name: "business",
      component: business,
      meta: {
        title: "商务合作 | MANA"
      }
    },
    {
      path: "/advertisement",
      name: "advertisement",
      component: advertisement,
      meta: {
        title: "广告刊例 | MANA"
      }
    },
    {
      path: "/service",
      name: "service",
      component: service,
      meta: {
        title: "产商服务 | MANA"
      }
    },
    {
      path: "/2020AnnualFeaturedWorks",
      name: 'yearList2020',
      component: yearList2020,
      meta: {
        title: "年度盘点 | MANA"
      }
    },
    {
      path: "/2021AnnualFeaturedWorks",
      name: 'yearList2021',
      component: yearList2021,
      meta: {
        title: "年度盘点 | MANA"
      }
    },
    {
      path: "/CQILAF2022",
      name: 'CQILAC2022',
      component: CQILAC2022,
      meta: {
        title: "2022中国·重庆首届国际光影艺术节 | MANA"
      }
    },
    {
      path: "/CQILAF2023",
      name: 'CQILAC2023',
      component: CQILAC2023,
      meta: {
        title: "2023中国·重庆首届国际光影艺术节 | MANA"
      }
    },
    {
      path: "/passport/auth",
      name: "Auth",
      component: Auth,
      meta: {
        title: "授权 | MANA"
      }
    },
    {
      path: "/playlist/:id",
      name: "lookFolder",
      component: lookFolder,
      meta: {
        title: "看单主页 | MANA"
      }
    },
    {
      path: '/hotList/:step',
      name: "hotLost",
      component: HotList,
      meta: {
        keepAlive: true,
        title: '榜单'
      }
    },
    {
      path: '/2022GradSHOWSchoolofDesign&InnovationofCAA',
      name: "guomei",
      component: guomei,
      meta: {
        title: '中国美术学院创新设计学院二O二二届毕业展'
      }
    },
    {
      path: '/releasePosition',
      name: "releasePosition",
      component: releasePosition,
      meta: {
        title: '招聘'
      }
    },
    {
      path: '/2022GradSHOWSchoolofDesign&InnovationofCAA/:type',
      name: "guomeiList",
      component: guomeiList,
      meta: {
        title: '中国美术学院创新设计学院二O二二届毕业展'
      }
    },
    {
      path: '/recruitDetail/:id',
      name: "recruitDetail",
      component: recruitDetail,
      meta: {
        title: '招聘详情'
      }
    },
    {
      path: '/MyRecruit',
      name: "MyRecruit",
      component: MyRecruit,
      meta: {
        title: '职位管理'
      }
    },
    {
      path: '/Resume',
      name: "Resume",
      component: Resume,
      meta: {
        title: '收到的简历'
      }
    },
    {
      path: '/jobWanted',
      name: "jobWanted",
      component: jobWanted,
      meta: {
        title: '求职管理'
      }
    },
    {
      path: '/MyResume',
      name: "MyResume",
      component: MyResume,
      meta: {
        title: '我的简历'
      }
    },
    {
      path: '/previewResume/:id',
      name: "previewResume",
      component: previewResume,
      meta: {
        title: '预览简历'
      }
    },
    {
      path: "/404",
      name: "404",
      component: NotFound,
      meta: {
        title: "页面未找到 | MANA"
      }
    },
    {
      path: "*",
      redirect: "/404"
    }
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //如果设置标题，拦截后设置标题
    document.title = to.meta.title;
  }
  Vue.prototype.$query = to.query;
  next();
});


router.afterEach(to => {
  let text = '/';
  const fullPath = to.fullPath;
  switch (to.path) {
    case '/discussDetail':
      text = `/questionDetail/${comm.getParam("id", fullPath)}`;
      break;
    case '/video/detail':
      text = `/VideoPlayer?videoId=${comm.getParam("id", fullPath)}`;
      break;
    case '/channel':
      text = `/channel?type=${comm.getParam("type", fullPath)}`;
      break;
    case '/peopleCenter':
      text = `/otherPeople?userId=${comm.getParam("userId", fullPath)}`;
      break;
    case '/login':
      text = "/login";
      break;
    case '/emailink':
      const type = comm.getParam("type", fullPath);
      if (type === '1' || type === '3') {
        text = "/login";
      } else {
        text = "/resetPassword" + location.search;
      }
      break;
    default:
      switch (true) {
        case /^\/activityDetail/.test(fullPath):
          text = fullPath.replace('activityDetail', 'ActivityDetail');
          break;
        case /^\/activity\/\d*\/detail$/.test(fullPath):
          text = fullPath
            .replace("/detail", "")
            .replace("/activity", "/ActivityDetail");
          break;
        case /^\/match\//.test(fullPath):
        case /^\/event\//.test(fullPath):
          text = fullPath;
          break;
        case /^\/subjectdetail/.test(to.path.toLocaleLowerCase()):
          text = `/topicIntroduce?topicId=${to.path.toLocaleLowerCase().split('subjectdetail/')[1].split('/')[0]}`;
          break;
        default:
          break;
      }
  }
  document.head.querySelector('link[rel="alternate"]').href = `https://m.manamana.net${text}`;
  let hash = "";
  let navLanguage = navigator.language || navigator.userLanguage;
  if (location.hash) {
    hash = location.hash;
  } else if (localStorage.getItem('language')) {
    if (localStorage.getItem('language') == '#!en' || localStorage.getItem('language') == '#!zh') {
      hash = localStorage.getItem('language');
    } else {
      if (navLanguage) {
        hash = navLanguage.substr(0, 2) == 'zh' ? '#!zh' : '#!en';
      } else {
        hash = '#!zh'
      }
    }
  } else {
    if (navLanguage) {
      hash = navLanguage.substr(0, 2) == 'zh' ? '#!zh' : '#!en';
    } else {
      hash = '#!zh'
    }
  }
  localStorage.setItem('language', hash);
  setTimeout(() => window.history.replaceState(null, null, location.pathname + location.search + hash));
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js